import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DraftPropertyListDto } from '@workspace/data-types';
import { AuraClipboardComponent, CountryIso2Pipe } from '@workspace/ng-aura';
import { ApplicationStore } from '@workspace/ng-data-access';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-property-draft-card',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    CountryIso2Pipe,
    AuraClipboardComponent,
    EtxeEnumDisplayPipe,
  ],
  templateUrl: './property-draft-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDraftCardComponent {
  appStore = inject(ApplicationStore);

  draft = input.required<DraftPropertyListDto>();

  selected = output<DraftPropertyListDto>();
  deleted = output<DraftPropertyListDto>();

  onSelect(): void {
    this.selected.emit(this.draft());
  }

  onDelete(): void {
    this.deleted.emit(this.draft());
  }
}
